import PrettyMailSettingsPage from './PrettyMailSettingsPage';

export const components = {
  PrettyMailSettingsPage,
};
